import { z } from "zod";

const artefactSchema = z
  .null()
  .or(z.undefined())
  .or(
    z.object({
      id: z.number().optional(),
      chatMessageId: z.number().min(1),
      image: z.object({ url: z.string().min(1) }),
      titlePopUp: z.string().min(1),
      textPopUp: z.string().min(1),
      reward: z.coerce.number().min(0),
    }),
  );

const htmlColorInputSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/, {
  message:
    "Invalid color format. Must be a 7-character hex code (e.g., #RRGGBB).",
});

export const CryptorSchema = z.object({
  id: z.number().optional(),
  name: z.string().min(1),
  reward: z.coerce.number().gte(0),
  image: z.object({ url: z.string().min(1) }),
  mapIcon: z.object({ url: z.string().nullable() }).nullable().optional(),
  obfuscatedImage: z.object({ url: z.string().min(1) }),
  avatar: z.object({ image: z.object({ url: z.string().min(1) }) }),
  characterImage: z.object({ url: z.string().min(1) }),
  primaryColor: z
    .string()
    .refine((val) => htmlColorInputSchema.safeParse(val).success),
  secondaryColor: z
    .string()
    .refine((val) => htmlColorInputSchema.safeParse(val).success),
  timeRestriction: z.boolean(),
  timeRestrictionUrl: z.string().optional(),
  underMaintenance: z.boolean(),
  addresses: z.array(
    z.object({
      locationAddress: z.string().min(1),
      cityId: z.number().min(1),
      location: z.object({
        latitude: z.coerce.number().min(-90).max(90),
        longitude: z.coerce.number().min(-180).max(180),
      }),
      locationRadius: z.coerce.number().min(0).nullable(),
    }),
  ),
  birthDate: z.date().or(z.string().min(1)).nullish(),
  birthDateRaw: z.string().max(20).nullish(),
  deathDate: z.date().or(z.string().min(1)).nullish(),
  placeOfBirth: z.string().nullable(),
  title: z.string().optional(),
  linkWithThePlace: z.string().optional(),
  description: z.string().optional(),
  quote: z.string().optional(),
  difficulty: z.string().optional(),
  artefactLinkWithThePlace: artefactSchema,
  artefactDescription: artefactSchema,
  artefactQuote: artefactSchema,
  archived: z.boolean(),
  draft: z.boolean(),
  descriptionForAI: z.string().optional(),
  mistralAIAgentIdFR: z.string().optional(),
  mistralAIAgentIdEN: z.string().optional(),
  mistralAIAgentIdES: z.string().optional(),
  mistralAIAgentIdDE: z.string().optional(),
  mistralAIAgentIdHU: z.string().optional(),
  mistralAIAgentIdIT: z.string().optional(),
  mistralAIAgentIdNL: z.string().optional(),
  mistralAIAgentIdPL: z.string().optional(),
  mistralAIAgentIdPT: z.string().optional(),
  shouldAnimateEyes: z.boolean().optional(),
});

export type CryptorFormData = z.infer<typeof CryptorSchema>;
